export default __webpack_public_path__ + "shake-for-developers.jpg";